import { RevolveFeatureDefinitionModel } from '../../definition/revolve/RevolveFeatureDefinition';
import {
    RevolveFeatureCommandParamsBuilder,
    type RevolveFeatureBaseCommandParams,
} from './RevolveFeatureCommandParamsBuilder';
import type { RevolveFeatureEditDefinition } from './RevolveFeatureEditDefinition';

/**
 * 文件定位：
 * 1. 当前文件位于 cad-core/feature/edit/revolve 层；
 * 2. 负责把旋转编辑定义提升为正式特征定义对象；
 * 3. 该类是命令参数构造与 FeatureDefinition 包装之间的单一职责边界。
 *
 * 文件职责：
 * 1. 委托命令参数构造器生成 RevolveParams；
 * 2. 统一创建 RevolveFeatureDefinitionModel；
 * 3. 避免 SessionBridge 直接关心定义对象构造细节。
 */

/**
 * 旋转特征定义构造器。
 */
export class RevolveFeatureDefinitionBuilder {
    /**
     * 构建旋转特征定义。
     *
     * @param input 构建输入。
     * @returns 旋转特征定义模型。
     */
    public static buildFeatureDefinition(input: {
        baseParams: RevolveFeatureBaseCommandParams;
        definition: RevolveFeatureEditDefinition;
    }): RevolveFeatureDefinitionModel {
        return RevolveFeatureDefinitionModel.fromParams({
            commandParams: RevolveFeatureCommandParamsBuilder.buildCommandParams(
                input.baseParams,
                input.definition,
            ),
        });
    }
}
